import { ErrorPage } from './error.page';

export default ErrorPage;
